/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for reading a lesson.
 * @export
 * @interface LessonRead
 */
export interface LessonRead {
    /**
     * 
     * @type {string}
     * @memberof LessonRead
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LessonRead
     */
    topic?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LessonRead
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LessonRead
     */
    order?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LessonRead
     */
    deleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LessonRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LessonRead
     */
    tutorial_id: string;
    /**
     * 
     * @type {Date}
     * @memberof LessonRead
     */
    created_at: Date;
}

/**
 * Check if a given object implements the LessonRead interface.
 */
export function instanceOfLessonRead(value: object): value is LessonRead {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tutorial_id' in value) || value['tutorial_id'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function LessonReadFromJSON(json: any): LessonRead {
    return LessonReadFromJSONTyped(json, false);
}

export function LessonReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): LessonRead {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'topic': json['topic'] == null ? undefined : json['topic'],
        'description': json['description'] == null ? undefined : json['description'],
        'order': json['order'] == null ? undefined : json['order'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'id': json['id'],
        'tutorial_id': json['tutorial_id'],
        'created_at': (new Date(json['created_at'])),
    };
}

export function LessonReadToJSON(json: any): LessonRead {
    return LessonReadToJSONTyped(json, false);
}

export function LessonReadToJSONTyped(value?: LessonRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'topic': value['topic'],
        'description': value['description'],
        'order': value['order'],
        'deleted': value['deleted'],
        'id': value['id'],
        'tutorial_id': value['tutorial_id'],
        'created_at': ((value['created_at']).toISOString()),
    };
}

